import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';

class Header extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { lang, trans } = this.props;
        const code = (lang != "" ? ("/" + lang) : "");
        return (
            <div className="image-section newsletter">
                <div className="image-section-overlay pricing">
                    <div className="container w-container">
                        <div className="section-title-wrapper full-centered">
                            <h2 className="section-title">
                                {trans('Want')} <strong>1</strong> <strong>{trans('FREE month')}</strong> {trans('off our PRO plan')}?
                            </h2>
                            <div className="section-description">
                                {trans('Join our list to receive more Discounts and Valuable Offers for your chatbots in the future')}
                            </div>
                        </div>
                        <div className="contact-form w-form">
                            <form id="wf-form-Newsletter-Form" name="wf-form-Newsletter-Form" data-name="Newsletter Form" action="https://HansaBot.com/subscribe/post?u=66c1fb87dba7e0f3f0d7cf282&amp;amp;id=221168d1c9" method="post">
                                <div className="w-row">
                                    <div className="w-col w-col-4">
                                        <input className="field email w-input" maxLength="256" name="EMAIL" data-name="EMAIL"
                                            placeholder={trans('Your email address')} id="mce-EMAIL" required="" type="email" />
                                        <div className="w-embed">
                                            <div style={{position: "absolute", left: "-5000px"}} aria-hidden="true">
                                                <input name="b_66c1fb87dba7e0f3f0d7cf282_221168d1c9" tabIndex="-1" type="text" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-col w-col-4">
                                        <select id="mce-BGROUND" name="BGROUND" data-name="BGROUND" className="field position w-select">
                                            <option defaultValue="Developer">{trans('Your background')}</option>
                                            <option value="Developer">{trans('Developer')}</option>
                                            <option value="Sales &amp;amp; Marketing">{trans('Sales and Marketing')}</option>
                                            <option value="Middle Management">{trans('Middle Management')}</option>
                                            <option value="Executive Position">{trans('Executive Position')}</option>
                                            <option value="Others">{trans('Others')}</option>
                                        </select>
                                    </div>
                                    <div className="w-col w-col-4">
                                        <input value={trans('Yes I want')}
                                            data-wait="Please wait..." id="mc-embedded-subscribe"
                                            className="button submit-newsletter w-button" type="submit" />
                                    </div>
                                </div>
                            </form>
                            <div className="success-message w-form-done">
                                <p>
                                    {trans('Thank you Your submission has been received')}
                                </p>
                            </div>
                            <div className="error-bg w-form-fail">
                                <p>
                                    {trans('Oops Something went wrong while submitting the form')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default connect(state => ({
    lang: state.app.lang
}))(Header);



// WEBPACK FOOTER //
// ./src/components/NewsLetter.js